import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ── Social sharing meta tags (added before React render for crawlers) ──
const ogMeta: Record<string, string> = {
  'og:title': 'ELVORA — Offshore & Marine Crew Solutions',
  'og:description': 'Operational and technical support for marine and offshore projects. Crew management, recruitment, and consulting services.',
  'og:type': 'website',
  'og:url': 'https://elvora.consulting',
  'og:image': 'https://cdn.magicpatterns.com/uploads/hd63eWM8qU6xYgaTeUajxL/fe82af34c545db296387cb3852bc1586e5585ff9.jpg',
  'og:site_name': 'ELVORA Consulting',
  'og:locale': 'en_US'
};
Object.entries(ogMeta).forEach(([property, content]) => {
  const meta = document.createElement('meta');
  meta.setAttribute('property', property);
  meta.setAttribute('content', content);
  document.head.appendChild(meta);
});
// Twitter Card tags
const twitterMeta: Record<string, string> = {
  'twitter:card': 'summary_large_image',
  'twitter:title': 'ELVORA — Offshore & Marine Crew Solutions',
  'twitter:description': 'Operational and technical support for marine and offshore projects.',
  'twitter:image': 'https://cdn.magicpatterns.com/uploads/hd63eWM8qU6xYgaTeUajxL/fe82af34c545db296387cb3852bc1586e5585ff9.jpg'
};
Object.entries(twitterMeta).forEach(([name, content]) => {
  const meta = document.createElement('meta');
  meta.setAttribute('name', name);
  meta.setAttribute('content', content);
  document.head.appendChild(meta);
});
// Base meta description
const descMeta = document.createElement('meta');
descMeta.name = 'description';
descMeta.content = 'ELVORA — Operational and technical support for marine and offshore projects. Crew management, recruitment, and consulting services.';
document.head.appendChild(descMeta);
// Only essential preconnects (max 3 — Lighthouse warns about >4)
const preconnects = [{
  href: 'https://fonts.gstatic.com',
  crossorigin: true
}, {
  href: 'https://cdn.magicpatterns.com',
  crossorigin: true
}];
preconnects.forEach(({
  href,
  crossorigin
}) => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossorigin) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});
// Preload hero image for LCP optimization
const heroPreload = document.createElement('link');
heroPreload.rel = 'preload';
heroPreload.as = 'image';
heroPreload.href = 'https://cdn.magicpatterns.com/uploads/hd63eWM8qU6xYgaTeUajxL/fe82af34c545db296387cb3852bc1586e5585ff9.jpg';
document.head.appendChild(heroPreload);
// Meta robots tag
const robotsMeta = document.createElement('meta');
robotsMeta.name = 'robots';
robotsMeta.content = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
document.head.appendChild(robotsMeta);
// Load Google Fonts non-blocking
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
fontLink.media = 'print';
fontLink.onload = function () {
  ;
  (this as HTMLLinkElement).media = 'all';
};
document.head.appendChild(fontLink);
// Set page title
document.title = 'ELVORA — Offshore & Marine Crew Solutions';
render(<App data-id="element-596" />, document.getElementById('root'));